import { Component, inject, type OnDestroy, type OnInit } from '@angular/core';
import { type NavigationExtras, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthUserService } from '../auth-user.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit, OnDestroy {
  private authUserService = inject(AuthUserService);
  private router = inject(Router);

  subscriptions = new Subscription();

  ngOnInit() {
    this.authUserService.userOrgObj.subscribe({
      next: (userOrgObj) => {
        const navigationExtras: NavigationExtras = { replaceUrl: true };

        if (!userOrgObj) {
          this.router.navigate(['/org-create'], navigationExtras);
        } else {
          const userId = userOrgObj.user._id;
          const firstSpace = userOrgObj.org.spaces.find((s) =>
            s.users.find((u) => u._id === userId)
          );
          if (firstSpace) {
            navigationExtras.queryParams = { userId };
            this.router.navigate(
              ['/org', userOrgObj.org._id, 'space', firstSpace._id, 'current'],
              navigationExtras
            );
          } else {
            this.router.navigate(
              ['/org', userOrgObj.org._id, 'inbox'],
              navigationExtras
            );
          }
        }
      },
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
